import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { API_BASE_URL } from '../utils/constants';
import { fetchHeroSlides } from '../api/heroSlider';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const HeroSlider = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const loadSlides = async () => {
      try {
        const data = await fetchHeroSlides();
        setSlides(data);
      } catch (err) {
        console.error('Failed to load hero slides:', err);
      }
    };
    
    loadSlides();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="w-full overflow-hidden">
      <Slider {...settings}>
        {slides.map((slide) => (
          <div key={slide.id} className="relative w-full h-[405px]">
            <img
              src={`${API_BASE_URL}/uploads/${slide.image}`}
              alt={slide.text || 'Hero Image'}
              className="w-full h-full object-cover object-left max-md:object-left sm:object-center w-full h-48"
            />
            {slide.text && (
              <div className="absolute inset-0 flex items-center justify-center">
                <h2 className="text-white text-3xl md:text-5xl font-bold bg-black bg-opacity-50 p-4 rounded">
                  {slide.text}
                </h2>
              </div>
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroSlider;
